import * as React from "react";
export function SvgSpacesMediumFlow(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={24} {...props}>
      <path
        d="M13 11h7c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-7c-.6 0-1 .4-1 1v2h-2c-.3-1.7-1.7-3-3.5-3C4.6 4 3 5.6 3 7.5S4.6 11 6.5 11c.3 0 .6 0 .8-.1l4.7 5.6V19c0 .6.4 1 1 1h7c.6 0 1-.4 1-1v-5c0-.6-.4-1-1-1h-7c-.6 0-1 .4-1 1v.9l-3.7-4.4C9.2 10 9.8 9.1 10 8h2v2c0 .6.4 1 1 1zm7-6v5h-7V5h7zm0 9v5h-7v-5h7zM6.5 10C5.1 10 4 8.9 4 7.5S5.1 5 6.5 5 9 6.1 9 7.5 7.9 10 6.5 10z"
        fill="#676767"
      />
    </svg>
  );
}
